export const API_PATH_apiWorkzoneItemPut = '/services/workzones-management/item';
